<template>
  <div>
    <b-row class="no-gutters align-items-center">
      <b-col :cols="hasSearch ? '' : '3'" md="4" sm="3" lg="6">
        <h4
          :class="[
            !hasSearch ? 'text-nowrap' : '',
            'mr-sm-4 mb-0 header-tablepage ',
          ]"
        >
          {{ title }}
        </h4>
      </b-col>
      <b-col
        md="8"
        sm="9"
        lg="6"
        class="text-right mt-2 mt-sm-0"
        v-if="hasSearch"
      >
        <b-input-group>
          <b-form-input
            type="search"
            id="header-search-bar"
            class="search-bar"
            @keyup.enter="handleSearch"
            @keypress="handleSearch"
            :placeholder="placeholder"
            v-model="filter.search"
            :disabled="tab === 3 ? true : false"
          >
          </b-form-input>
          <b-input-group-append is-text class="mr-2">
            <b-iconstack
              font-scale="2"
              type="submit"
              @click="handleSearch"
              :disabled="tab === 3 ? true : false"
            >
              <b-icon stacked icon="search" scale="0.5" variant="grey"></b-icon>
            </b-iconstack>
          </b-input-group-append>
          <b-button
            v-if="hasFilter"
            @click.prevent="sidebarFilter"
            class="btn-filter mr-2"
            :disabled="tab === 3 ? true : false"
          >
            <font-awesome-icon icon="filter" class="text-black d-sm-none" />
            <span class="d-none d-sm-block">
              <font-awesome-icon icon="filter" class="pointer" />
              Filter
            </span>
          </b-button>
          <b-dropdown
            v-if="hasDropdown"
            id="dropdown"
            right
            text="Option"
            class="btn-mobile"
          >
            <b-dropdown-item :href="routerPath">
              <router-link :to="routerPath" class="ml-1" id="create-new-staff">
                <font-awesome-icon icon="plus" class="text-black d-sm-none" />
                <span class="d-none d-sm-block">
                  <font-awesome-icon icon="plus-square" class="pointer" />
                  Create new
                </span>
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item href="#">
              <font-awesome-icon icon="filter" class="text-black d-sm-none" />
              <span class="d-none d-sm-block">
                <font-awesome-icon icon="file-export" class="pointer" />
                Export File
              </span>
            </b-dropdown-item>
          </b-dropdown>
          <router-link :to="routerPath" v-else-if="routerPath" exact>
            <button type="button" class="btn button btn-mobile">
              <font-awesome-icon icon="plus" class="text-black d-sm-none" />
              <span class="d-none d-sm-block">
                <font-awesome-icon icon="plus-square" class="pointer" />
                Create New
              </span>
            </button>
          </router-link>
          <button
            @click="$emit('btnMethods')"
            type="button"
            class="btn button btn-mobile"
            v-else-if="hideCreate"
          >
            <font-awesome-icon icon="plus" class="text-black d-sm-none" />
            <span class="d-none d-sm-block">
              <font-awesome-icon icon="plus-square" class="pointer" />
              Create New
            </span>
          </button>
        </b-input-group>
      </b-col>
      <b-col v-else class="text-right" md="8" cols="9" sm="9" lg="6">
        <b-button
          v-if="hasFilter"
          @click.prevent="sidebarFilter"
          class="btn-filter"
          :disabled="tab === 3 ? true : false"
        >
          <font-awesome-icon icon="filter" class="text-black d-sm-none" />
          <span class="d-none d-sm-block">
            <font-awesome-icon icon="filter" class="pointer" />
            Filter
          </span>
        </b-button>
        <b-dropdown
          v-if="hasDropdown"
          id="dropdown"
          right
          text="Option"
          class="btn-mobile"
        >
          <b-dropdown-item :href="routerPath">
            <router-link :to="routerPath" id="create-new-staff">
              <font-awesome-icon icon="plus" class="text-black d-sm-none" />
              <span class="d-none d-sm-block">
                <font-awesome-icon icon="plus-square" class="pointer" />
                Create new
              </span>
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item href="#">
            <font-awesome-icon icon="filter" class="text-black d-sm-none" />
            <span class="d-none d-sm-block">
              <font-awesome-icon icon="file-export" class="pointer" />
              Export File
            </span>
          </b-dropdown-item>
        </b-dropdown>
        <router-link :to="routerPath" v-else>
          <button type="button" class="btn button btn-mobile">
            <font-awesome-icon icon="plus" class="text-black d-sm-none" />
            <span class="d-none d-sm-block">
              <font-awesome-icon icon="plus-square" class="pointer" />
              Create New
            </span>
          </button>
        </router-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
      type: String,
    },
    filter: {
      required: true,
      type: Object,
    },
    placeholder: {
      required: false,
      type: String,
    },
    btnFilter: {
      required: false,
      type: Boolean,
    },
    btnExport: {
      required: false,
      type: Boolean,
    },
    tab: {
      required: false,
      type: Number,
    },
    routerPath: {
      required: false,
    },
    hasDropdown: {
      required: false,
      default: true,
    },
    hasFilter: {
      required: false,
      default: true,
    },
    hasSearch: {
      default: true,
      required: false,
    },
    btnMethods: {
      required: false,
    },
    hideCreate: {
      required: false,
      default: true,
    },
  },
  methods: {
    handleSearch(e) {
      if (e.type === "keyup") {
        if (e.keyCode === 13) {
          this.$emit("search", this.filter);
        }
      } else if (e.type === "click") {
        this.$emit("search", this.filter);
      }
      // else if (e.type === "keypress") {
      //   setTimeout(() => {
      //     this.$emit("search", this.filter);
      //   }, 1500)
      // }
    },
    exportExcel() {
      this.$emit("confirmExport");
    },
    sidebarFilter() {
      this.$emit("sidebar");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .input-group-text {
  background-color: #fff;
  padding: 0 0.75rem;
}
::v-deep .btn-filter button,
.btn-filter {
  color: var(--primary-color) !important;
  border-color: var(--primary-color);
  font-weight: 100;
}
::v-deep .form-control:disabled,
.form-control[readonly] {
  background-color: #fafafa;
}
.form-control:focus {
  border-color: var(--primary-color);
}
::v-deep .dropdown-toggle.btn-secondary {
  background-color: #fff;
  color: var(--primary-color);
  border-color: var(--primary-color);
}
::v-deep .dropdown-item:active {
  text-decoration: none;
  background-color: #fff;
  color: var(--primary-color) !important;
}
::v-deep .dropdown-menu li:hover {
  text-decoration: none;
  background-color: #fff;
  color: var(--primary-color) !important;
}
input#header-search-bar::placeholder {
  text-transform: capitalize;
}
.input-group > .input-group-append:not(:last-child) > .input-group-text {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
</style>
